import type { ISerialize } from '@/objects/ISerialize';

export class RaceContestantWithTimesRequest implements ISerialize {
    public Bib: number;

    public RaceID: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Bib?: number; RaceID?: number | null }) {
        this.Bib = values.Bib ?? 0;

        this.RaceID = values.RaceID ?? null;
    }

    public serialize(): string {
        return '{' + `"Bib": ${JSON.stringify(this.Bib)}` + ',' + `"RaceID": ${JSON.stringify(this.RaceID)}` + '}';
    }

    /**
     * Creates an instance of RaceContestantWithTimesRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Bib?: number; RaceID?: number | null }): RaceContestantWithTimesRequest {
        return new RaceContestantWithTimesRequest(values);
    }

    public static _FromServerJson(json: any): RaceContestantWithTimesRequest {
        return new RaceContestantWithTimesRequest({ Bib: json.Bib, RaceID: json.RaceID ?? null });
    }

    /**
     * Creates an instance of RaceContestantWithTimesRequest from another instance of RaceContestantWithTimesRequest.
     * @param other The RaceContestantWithTimesRequest you want to clone
     * @returns A cloned RaceContestantWithTimesRequest
     */
    public static FromOther(other: RaceContestantWithTimesRequest): RaceContestantWithTimesRequest {
        return RaceContestantWithTimesRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return RaceContestantWithTimesRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'RaceContestantWithTimesRequest';
}
